
























































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { General } from '@/services/General';
import ProductDetail from '@/components/ProductDetail.vue'

@Component({

    components: {
        ProductDetail
    }
})
export default class DocumentSearch extends Vue {

    @Prop({ default: true })
    public showDetail: boolean;

    @Prop({ default: false })
    public multiSelect: boolean;

    @Prop({ default: false })
    public linkSearch: boolean;

    productsSelected: any[] = [];
    showDetailInternal: boolean = false;
    idProductDetail: any = null;
    produtCodeSelected: string = null;
    general: any = {};
    freeText = null;
    showLoading: boolean = false;
    ready: boolean = false;
    firstSearch: boolean = false;
    resultsItems: any = {
        resultPage: new Array(),
        total: 0
    };
    page: number = 1;
    selectedLanguage: any = null;
    selectedLanguageChange: boolean = false;
    showChage: boolean = false;
    optionsLanguage: any = new Array();
    selectedCulture: any = null;
    countryAuthorityList: any[] = null;
    defaultLanguage = { value: null, text: 'Please select a language' }; 
    showInfo: boolean = false;
    FilterDocuments(items: any[], documentType: string): any[] {
        if (items) {
            return items.filter(p => p.documentType.code == documentType);
        }
        return [];

    }
    get ProductTitle(): string {
        return `Product code: ${this.produtCodeSelected}`;
    }
    mounted() {
            this.getLanguages(true); 
            this.showDetailInternal = false;
        //if (this.mode == 2) {
        //    this.ready = true;
        //    this.showDetailInternal = this.showDetail;
        //}
        this.general = General;

        if (this.$route.params.id) {
            let app: any = this;
            let productCode: string = this.$route.params.id;
            let promise = this.getProductId(productCode);
            promise.then(function (val) {
                let product: any = {
                    code: productCode,
                    idProduct: val
                };
                app.openProduct(product, true);

            });
        }
    }

    convertLanguageToSelect(data: any, addEmpty: boolean) { 
        let outputData = new Array();
        if (addEmpty) outputData.push(this.defaultLanguage);
        data.forEach(function (item: any) {
            outputData.push({
                value: item.idLanguage,
                text: item.name
            });
        });
        return outputData;
    };
    @Watch('selectedLanguage')
    selectedChanger() {
        this.selectedLanguageChange = true;

    }

    async getProductId(productCode: string) {
        let idProduct: string = null;

        try {
            let response = await axios({
                method: 'get',
                url: General.GetApiUrl('/api/product/GetProductByCode?productCode=' + productCode),
                responseType: 'json',
                withCredentials: false
            });
            idProduct = response.data;
        } catch (error) {
            General.HandleError(error, this);

        }

        return idProduct;
    }
    async getLanguages(emptyPolicy: boolean) {

        this.showLoading = true;
        try {
            let apiUrl = General.GetApiUrl('/api/culture/GetLanguages/?emptyLanguagesPolicy=' + ((emptyPolicy == true) ? '1' : '0'));
            let response: any = await axios({
                method: 'get',
                url: apiUrl,
                responseType: 'json'
            });

            this.optionsLanguage = this.convertLanguageToSelect(response.data, true);
            this.showLoading = false;
            this.ready = true;
        } catch (error) {
            General.HandleError(error, this);
        }

    }
    openProduct(product: any, forceOpen: boolean) {
        if (!forceOpen) this.$router.push('/products/' + product.code);
        this.idProductDetail = product.idProduct;
        this.produtCodeSelected = product.code;
        this.$bvModal.show('product-detail-modal');
    }
    close() {
        this.$bvModal.hide('product-detail-modal');
    }
    resetSearch() {
        this.firstSearch = false;
        this.resultsItems.resultPage.splice(0);
        this.page = 1;
    }
    async searchProductDo(start: boolean) {

        this.showLoading = true;
        if (start == true)
            this.resetSearch();
        try {

            let results: any = await axios({
                method: 'post',
                url: General.GetApiUrl('/api/product/GetProductsWithFilter'),
                data: {
                    FreeText: this.freeText,
                    IdLanguage: this.selectedCulture.language.idLanguage,
                    IdCountry: this.selectedCulture.country.idCountry,
                    PublicSearch: true,
                    ShowEmptyProducts: false,
                    CurrentPage: this.page

                },
                withCredentials: true,
                responseType: 'json'
            });

            this.resultsItems.resultPage = this.resultsItems.resultPage.concat(results.data.listPage);
            this.resultsItems.total = results.data.total;
            if (this.countryAuthorityList != null && this.countryAuthorityList.length > 1) {
                this.showChage = true;
            } else {
                this.showChage = false;
            }

            this.firstSearch = true;
            this.page += 1;

            this.showLoading = false;
        } catch (error) {
            General.HandleError(error, this);
            this.showLoading = false;
        }

    }
    searchItems(start: boolean) {
        let app = this;
        if (this.selectedLanguage == null) {
            General.showAlertDanger('Please select a language', app);
        }
        else {
            if ((this.selectedCulture == null || this.selectedLanguageChange == true)) {
                this.checkCountrySelector(start);
            } else {
                this.searchProductDo(start); //Mettere in productSearch
            }
        }
    }
    countrySelectorModal(open: boolean) {
        if (open == true) {
            this.$bvModal.show('country-authority-selector');
        } else {
            this.$bvModal.hide('country-authority-selector');
        }
    }

    checkCountrySelector(start: boolean) {
        this.selectedLanguageChange = false;
        let url: string = '/api/culture/GetCulturesWithFilter?countryType=COUNTRY_AUTHORITY&IdLanguage=' + this.selectedLanguage;
        this.countryAuthorityList = null;

        axios({
            method: 'get',
            url: General.GetApiUrl(url),
            withCredentials: true,
            responseType: 'json'
        }).then(({ data }) => {
            if (data.length == 1) {
                this.countryAuthorityList = null;
                this.selectedCulture = data[0];
                this.searchProductDo(start);
            } else {
                this.countryAuthorityList = data;
                this.countrySelectorModal(true);
            }
        })
    }
    countrySelector(culture: any) {
        this.selectedCulture = culture;
        this.countrySelectorModal(false);
        this.searchProductDo(true);
    }
    productsSelectedChange() {
        this.$emit('productsSelectedChange', this.productsSelected);
    }
}
